import { apiEndpoints } from "@/helpers";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";

export const AutoCompleteFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="url"
        label={intl.formatMessage({ id: "newFormField.endpoint" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.endpointRequired",
            }),
          },
        ]}
      >
        <Select>
          <Select.Option value={apiEndpoints.users.suggestions}>
            {intl.formatMessage({ id: "newFormField.endpoint_users" })}
          </Select.Option>
          <Select.Option value={apiEndpoints.departments.suggestions}>
            {intl.formatMessage({ id: "newFormField.endpoint_departments" })}
          </Select.Option>
        </Select>
      </Form.Item>
    </FormFieldContainer>
  );
};
